<div class="modal_dialog">
    <div class="modal_header">
      <h2>{{ 'Submit Cash' | translate }}</h2>
      <button class="btnn close_icon" [mat-dialog-close]> <mat-icon>close</mat-icon> </button>
    </div>
    <div class="modal_body">
        <!-- <form (ngSubmit)="onSubmit()"> -->
            <div class="gap_m">
              <div class="form_group w_50">
                <mat-label class="required">{{ 'Driver' | translate }} </mat-label>
                <mat-form-field appearance="fill">
                  <mat-select [formControl]="driverId" class="form_control">
                    <mat-option *ngFor="let driver of allDrivers" [value]="driver._id">{{driver.name}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="form_group w_50">
                  <mat-label class="required">{{ 'Cash Amount' | translate }} </mat-label>
        
                  <mat-form-field appearance="fill">
                    <input
                      matInput
                      placeholder="{{ 'Enter Cash Amount' | translate }}"
                      class="form_control"
                      type="number"
                      [formControl]="amount" />
                  </mat-form-field>
                </div>
      
            </div>
            <div class="submit_btn">
              <button class="btnn btn_primary" type="button" (click)="onSubmit()">
                {{ 'Submit' | translate }}
              </button>
            </div>
          <!-- </form> -->
    </div>
  </div>
  